// extracted by mini-css-extract-plugin
export default {"userManagement":"UserManagement_userManagement__QZDzD","contentTitle":"UserManagement_contentTitle__H5Vsv"};